import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import TurndownService from "turndown";

import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

// Añadido FerBcn 15/12/2025 - Imágenes desde URL para PDF
async function fetchAsDataURL(url) {
  const res = await fetch(url);
  const blob = await res.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
async function fetchAsBase64(url) {
  const dataUrl = await fetchAsDataURL(url); // ya la tienes
  return String(dataUrl).split(",")[1];      // quita "data:image/png;base64,"
}
function ts() {
  const d = new Date();
  const p2 = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${p2(d.getMonth() + 1)}${p2(d.getDate())}_${p2(d.getHours())}${p2(d.getMinutes())}${p2(d.getSeconds())}`;
}

function formatDateES(d = new Date()) {
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

function htmlToPlainTextPreserveNewlines(html = "") {
  let s = String(html);

  // Saltos de línea típicos en HTML
  s = s.replace(/<\s*br\s*\/?\s*>/gi, "\n");
  s = s.replace(/<\/\s*(p|div|li|tr|h\d)\s*>/gi, "\n");

  // Quita tags
  s = s.replace(/<[^>]+>/g, "");

  // Decodifica entidades comunes
  s = s.replace(/&nbsp;/gi, " ");
  s = s.replace(/&amp;/gi, "&");
  s = s.replace(/&quot;/gi, '"');
  s = s.replace(/&#39;/gi, "'");
  s = s.replace(/&lt;/gi, "<");
  s = s.replace(/&gt;/gi, ">");

  // Normaliza saltos
  s = s.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  // Evita espacios raros
  s = s.replace(/[ \t]+\n/g, "\n").replace(/\n[ \t]+/g, "\n");
  // Colapsa múltiples espacios
  s = s.replace(/[ \t]{2,}/g, " ");
  // Colapsa demasiados saltos
  s = s.replace(/\n{3,}/g, "\n\n");

  return s.trim();
}

// Fin añadido FerBcn

export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export const delay = (n) => new Promise((r) => setTimeout(r, n * 1000));

export const getNonEmpty = (field) => {
  const defaultLanguage = "es";
  if (!field || !Object.keys(field)?.length) return "----";
  if (field[defaultLanguage] && field[defaultLanguage] !== "")
    return field[defaultLanguage];
  for (const lang of Object.keys(field)) {
    if (field[lang] && field[lang] !== "") return field[lang];
  }
  return "----";
};

export const checkIsEmpty = (field) => {
  if (field === null || field === "" || field === " ") return true;
  return Object.values(field).every((x) => x === null || x === "" || x === " ");
};

export const getFileType = (fileName) => {
  if (!fileName) return "unknown";
  const ext = fileName.split(".").pop();
  switch (ext) {
    case "pdf":
      return "file";
    case "m4a":
      return "audio";
    case "mp3":
      return "audio";
    case "mpa":
      return "audio";
    case "wma":
      return "audio";
    case "aif":
      return "audio";
    case "cda":
      return "audio";
    case "mid":
      return "audio";
    case "midi":
      return "audio";
    case "ogg":
      return "audio";
    case "wav":
      return "audio";
    case "wpl":
      return "audio";
    case "jpg":
      return "image";
    case "jpeg":
      return "image";
    case "png":
      return "image";
    case "svg":
      return "image";
    case "gif":
      return "image";
    case "avi":
      return "video";
    case "m4v":
      return "video";
    case "mkw":
      return "video";
    case "mp4":
      return "video";
    case "wmv":
      return "video";
    case "mov":
      return "video";
    default:
      return "unknown";
  }
};

export function normalizeString(str) {
  if (!str) return "";
  return str
    .normalize("NFD")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ")
    .replace(/(?:^|\s)\S/g, (char) => char.toUpperCase());
}

// export function formatInstallationTime(minutes) {
//   if (!minutes) return 0;
//   const hours = Math.floor(minutes / 60)
//     .toString()
//     .padStart(2, "0");

//   const remainingMinutes = minutes % 60;

//   const formattedMinutes = remainingMinutes.toString().padStart(2, "0");

//   return `${hours}:${formattedMinutes}`;
// }

// export function calculateMinutesFromTime(time) {
//   if (!time) return null;
//   const [hours, minutes] = time.split(":").map(Number);

//   if (
//     isNaN(hours) ||
//     isNaN(minutes) ||
//     hours < 0 ||
//     minutes < 0 ||
//     minutes >= 60
//   ) {
//     return null;
//   }

//   return hours * 60 + minutes;
// }

//Cambio FerBcn 15/12/2025  -> El tiempo pasa a calcularse en segundos. (Mantenemos los nombres d elas funciones para evitar errores)
export function formatInstallationTime(seconds) {
  if (seconds === null || seconds === undefined) return "00:00:00";

  const total = Math.max(0, Number(seconds) || 0);

  const hh = Math.floor(total / 3600).toString().padStart(2, "0");
  const mm = Math.floor((total % 3600) / 60).toString().padStart(2, "0");
  const ss = Math.floor(total % 60).toString().padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
}

// Mantengo el nombre para que no tengas que cambiar imports,
// pero OJO: ahora devuelve SEGUNDOS.
export function calculateMinutesFromTime(time) {
  if (!time) return null;

  const normalizedTime = String(time).trim();
  const parts = normalizedTime.split(":").map((x) => Number(x));

  if (parts.length < 1 || parts.length > 3) {
    return null;
  }

  const hours = parts[0];
  const minutes = parts.length >= 2 ? parts[1] : 0;
  const seconds = parts.length >= 3 ? parts[2] : 0;

  if (
    Number.isNaN(hours) || Number.isNaN(minutes) || Number.isNaN(seconds) ||
    hours < 0 || minutes < 0 || seconds < 0 ||
    minutes >= 60 || seconds >= 60
  ) {
    return null;
  }

  return hours * 3600 + minutes * 60 + seconds;
}


function formatHtml(html) {
  return html
    .replace(/<br\s*\/?>/gi, "\n") // Convierte <br> en saltos de línea
    .replace(/<b>(.*?)<\/b>/gi, "*$1*") // Convierte <b> en texto con asteriscos (simulando negritas)
    .replace(/<[^>]*>/g, ""); // Elimina las demás etiquetas
}

function calcularAnchoTexto(doc, texto) {
  const textSize = doc.getTextDimensions(texto);
  return textSize.w + 4;
}

function formatNumber(num) {
  return num
    .toFixed(2)
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function getFinalAmount(finalValue, baseValue) {
  return Number(finalValue ?? baseValue ?? 0);
}

function getChapterTitle(chapter) {
  return String(
    chapter?.titulo_efectivo ||
      chapter?.titulo ||
      chapter?.partida_categoria?.descripcion ||
      "Capítulo"
  ).trim();
}

function checkPageBreak(doc, yOffset, margin = 20) {
  const pageHeight = doc.internal.pageSize.getHeight();
  if (yOffset + margin >= pageHeight) {
    doc.addPage();
    return 20; // Reiniciar yOffset al margen superior de la nueva página
  }
  return yOffset;
}


// GENERAR PDF ***************************************************************************************************************
// Cambios FerBcn 15/12/2025 -> Cambio a ASYNC para carga de imágenes desde URL
export async function generatePDF(oferta) {
  const doc = new jsPDF();

  const BRAND_BLUE = [83, 141, 213];      // $primary (#3699FF)
  const BRAND_BLUE_DARK = [83, 141, 213]; // un poco más oscuro para hover/variantes si lo usas
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginX = 15;


  const logoDataUrl = await fetchAsDataURL("/media/logo/NEO4Logo_white.png");

  // Tipos y tamaños (aprox al PDF)
  const FS_DATE = 10;
  const FS_TITLE = 12;
  const FS_SUB = 10;

  //Datos
  //const fecha = oferta?.fecha || formatDate(new Date()); // usa tu helper si ya lo tienes
  const fecha = oferta?.fecha ? formatDateES(new Date(oferta.fecha)) : formatDateES();
  const numPres = oferta?.num_oferta || "";
  const revision = oferta?.revision ?? 0;

  const cliente = oferta?.cliente_nombre || "";
  const localizacion = oferta?.localizacion || "";


  // Cabezera
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(16);
  // doc.text(`PRESUPUESTO Nº ${oferta.num_oferta}`, 20, 20);

  // doc.setFont("helvetica", "normal");
  // doc.setFontSize(12);
  // doc.text(` Revision  ${oferta.revision_num}`, 100, 20);
  // doc.text(`Peticionario/Cliente: ${oferta.cliente_nombre}`, 20, 30);
  // doc.text(`Localización/Obra: ${oferta.localizacion}`, 20, 40);
  // doc.text(`Referencia: ${oferta.referencia}`, 20, 50);

  // =========================
  // CABECERA (estilo cliente)
  // =========================


  // Logo grande arriba izquierda
  doc.addImage(logoDataUrl, "PNG", marginX, 10, 55, 22);

  // Fecha arriba derecha
  doc.setFont("helvetica", "normal");
  doc.setFontSize(FS_DATE);
  doc.setTextColor(0, 0, 0);
  doc.text(String(fecha), pageWidth - marginX, 15, { align: "right" });

  // Línea "PRESUPUESTO Nº" + barra con número + revisión
  let y = 45;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(FS_SUB);
  doc.setTextColor(0, 0, 0);
  doc.text("PRESUPUESTO  N°", marginX, y);

  // Barra con el número
  const barX = marginX + 38;
  const barY = y - 6;
  const barW = 92;   // ajusta si tu nº es más largo
  const barH = 8;

  doc.setFillColor(...BRAND_BLUE);
  doc.rect(barX, barY, barW, barH, "F");

  doc.setFont("helvetica", "bold");
  doc.setTextColor(255, 255, 255);
  doc.text(String(numPres), barX + 2, y);

  // Revisión a la derecha
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0);
  doc.text(`Revisión ${revision}`, barX + barW + 4, y);

  // Cliente
  y += 7;
  doc.setFont("helvetica", "normal");
  doc.text("Peticionario/Cliente:", marginX, y);
  doc.setFont("helvetica", "bold");
  doc.text(String(cliente), marginX + 42, y);

  // Localización
  y += 7;
  doc.setFont("helvetica", "normal");
  doc.text("Localización / Obra:", marginX, y);
  doc.setFont("helvetica", "bold");
  doc.text(String(localizacion), marginX + 42, y);

  // Cursor para contenido (arranca justo después de la cabecera)
  let yOffset = y + 38;


  // Capítulos
  yOffset = 80;
  const marginLeft = 20;
  const marginRight = 12;
  const rectWidth = doc.internal.pageSize.getWidth() - marginLeft - marginRight;
  const rectHeight = 8;

  // Dibujar fondo rojo para el título "MEDICIONES: INSTALACIONES"
  // doc.setFillColor(...BRAND_BLUE);
  // const xx = marginLeft;
  // const yy = yOffset - 5;
  // doc.rect(xx, yy, rectWidth, rectHeight, "F");

  // // Estilo del texto del título
  // doc.setTextColor(255, 255, 255);
  // doc.setFont("helvetica", "bold");
  // doc.text("MEDICIONES:     INSTALACIONES", marginLeft + 5, yOffset);
  // yOffset += 10;

  const turndownService = new TurndownService();
  const cabeceraTexto = turndownService.turndown(oferta.cabecera_descripcion);

  const splitDescripcion = doc.splitTextToSize(cabeceraTexto, rectWidth);

  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "normal");
  //doc.text(splitDescripcion, 25, yOffset);
  doc.text(cabeceraTexto, 25, yOffset, {
    maxWidth: rectWidth - 5,
    align: "justify",
  });
  yOffset += (splitDescripcion.length * 6) + 10;
  yOffset = checkPageBreak(doc, yOffset);

  oferta.capitulos.forEach((capitulo) => {
    doc.setFillColor(...BRAND_BLUE);
    const rectY = yOffset - 5;
    const rectX = marginLeft;
    doc.rect(rectX, rectY, rectWidth, rectHeight, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    const capitulo_inex = capitulo.ordinal + 1;
    const tituloCapitulo = getChapterTitle(capitulo);
    doc.text(
      `CAPÍTULO ${capitulo_inex}:    ${tituloCapitulo} `,
      25,
      yOffset
    );
    yOffset += 10;

    //Partidas dentro de capitulos
    capitulo.partidas.forEach((partida) => {
      yOffset = checkPageBreak(doc, yOffset);
      doc.setFont("helvetica", "normal");
      const anchoPrecio = calcularAnchoTexto(
        doc,
        `${formatNumber(getFinalAmount(partida.precio_unitario_final, partida.precio_unitario))} €`
      );
      const anchoTotal = calcularAnchoTexto(
        doc,
        `${formatNumber(getFinalAmount(partida.precio_total_final, partida.precio_total))} €`
      );
      autoTable(doc, {
        startY: yOffset,
        head: [["Pos.", "Ud.", "Descripción", "Med.", "Precio", "Total"]],
        body: [[
          `${capitulo_inex}.${partida.ordinal + 1}`,
          `${partida.tipo_unidad || "Ud."}`,
          `${partida.descripcion}\n${htmlToPlainTextPreserveNewlines(partida.concepto || "")}`,
          partida.unidades,
          `${formatNumber(getFinalAmount(partida.precio_unitario_final, partida.precio_unitario))} €`,
          `${formatNumber(getFinalAmount(partida.precio_total_final, partida.precio_total))} €`,
        ]],
        theme: "plain",
        margin: { top: 10, bottom: 18, left: 20, right: 12 }, // deja aire para el footer
        styles: {
          font: "helvetica",
          fontSize: 9,
          cellPadding: 2,
          overflow: "linebreak",
          valign: "top",
        },
        headStyles: {
          fontStyle: "bold",
          fontSize: 9,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0,
        },
        columnStyles: {
          0: { cellWidth: 15, halign: "center" },
          1: { cellWidth: 15, halign: "center" },
          2: { cellWidth: "auto", halign: "left", valign: "top" },
          3: { cellWidth: 15, halign: "center", valign: "middle" },
          4: { cellWidth: 25, halign: "center", valign: "middle" },
          5: { cellWidth: 25, halign: "center", valign: "middle" },
        },
      });

      yOffset = doc.lastAutoTable.finalY + 10;
      yOffset = checkPageBreak(doc, yOffset);
    });

    // Total del capítulo
    const totalCapitulo = getFinalAmount(capitulo.total_precio_final, capitulo.total_precio).toFixed(2);
    doc.setFillColor(...BRAND_BLUE);
    const rectY_final = yOffset - 5;
    const rectX_final = marginLeft;
    doc.rect(rectX_final, rectY_final, rectWidth, rectHeight, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text(
      `TOTAL CAPÍTULO ${capitulo_inex}:    ${tituloCapitulo} `,
      25,
      yOffset
    );

    // Total derecha
    doc.text(
      `${totalCapitulo} €`,
      pageWidth - 15,
      yOffset,
      { align: "right" }
    );
    yOffset += 20;
  });

  // Total Presupuesto
  // Definir las posiciones iniciales
  const marginLefttext = 20;
  //const pageWidth = doc.internal.pageSize.getWidth();
  const rightAlignX = pageWidth - marginLefttext;

  // Formatear valores numéricos en formato de moneda
  const totalPresupuesto = formatNumber(getFinalAmount(oferta.calc_total_pvp_final, oferta.calc_total_pvp)) + " €";
  const valorIVA = (oferta.valor_IVA * 100).toFixed(0) + "%";
  const aux = Number(oferta.total_PVP_IVA || 0) - getFinalAmount(oferta.calc_total_pvp_final, oferta.calc_total_pvp);
  const valorIVAEuros = formatNumber(aux) + " €";
  const totalConIVA = formatNumber(oferta.total_PVP_IVA) + " €";

  // Asegurar alineación correcta
  const lineSpacing = 8;
  yOffset += 10;
  yOffset = checkPageBreak(doc, yOffset);

  // Línea 1: INSTALACIONES
  doc.setFillColor(...BRAND_BLUE);
  let rectY = yOffset - 5;
  const rectX = marginLeft;
  doc.rect(rectX, rectY, rectWidth, rectHeight, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.text("TOTAL SIN IVA", marginLeft, yOffset);
  doc.text(
    totalPresupuesto,
    rightAlignX - doc.getTextWidth(totalPresupuesto),
    yOffset
  );

  // Línea 2: Tipo de IVA
  yOffset += lineSpacing;

  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "normal");
  doc.text("    Tipo de IVA APLICABLE ………………………………………………", marginLeft, yOffset);
  doc.text(
    valorIVA,
    rightAlignX -
    doc.getTextWidth(valorIVA) -
    doc.getTextWidth(valorIVAEuros) -
    10,
    yOffset
  );
  doc.text(
    valorIVAEuros,
    rightAlignX - doc.getTextWidth(valorIVAEuros),
    yOffset
  );

  // Línea 3: TOTAL IVA INCLUIDO
  yOffset += lineSpacing;
  doc.setFillColor(...BRAND_BLUE);
  rectY = yOffset - 5;
  doc.rect(rectX, rectY, rectWidth, rectHeight, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.text("TOTAL IVA INCLUIDO  ………………………………………………..", marginLeft, yOffset);
  doc.text(totalConIVA, rightAlignX - doc.getTextWidth(totalConIVA), yOffset);

  doc.addPage();
  yOffset = 20;

  // Dibujar fondo rojo para el título "MEDICIONES: INSTALACIONES"
  doc.setFillColor(...BRAND_BLUE);
  const xx2 = marginLeft;
  const yy2 = yOffset - 5;
  doc.rect(xx2, yy2, rectWidth, rectHeight, "F");

  // Estilo del texto del título
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.text(
    "                   CONDICIONES DE GARANTIAS y VENTA",
    marginLeft + 5,
    yOffset
  );
  yOffset += 10;

  const turndownService2 = new TurndownService();
  const cabeceraTexto2 = turndownService2.turndown(
    oferta.pie_condiciones_venta
  );

  const splitDescripcion2 = doc.splitTextToSize(cabeceraTexto2, rectWidth);

  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "normal");
  //doc.text(splitDescripcion2, 25, yOffset);
  doc.text(cabeceraTexto2, 25, yOffset, {
    maxWidth: rectWidth - 5,
    align: "justify",
  });
  // doc.text(cabeceraTexto, 25, yOffset, {
  //   maxWidth: rectWidth - 5,
  //   align: "justify",
  // });
  yOffset += splitDescripcion2.length * 5;
  yOffset += 10;

  doc.setFillColor(...BRAND_BLUE);
  rectY = yOffset - 5;
  doc.rect(rectX, rectY, rectWidth, rectHeight, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.text("        INSTALACIONES              ", marginLeft, yOffset);
  doc.text(totalConIVA, rightAlignX - doc.getTextWidth(totalConIVA), yOffset);


  // =========================
  // FOOTER EN TODAS LAS PÁGINAS
  // =========================

  const footerText =
    "Oficinas: C/ Baix Llobregat 10 , Vacarisses 08233 Barcelona Telf.:695.143.074 Email: neo.4@outlook.es";

  const pageCount = doc.getNumberOfPages();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Línea separadora fina
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.line(20, pageHeight - 13, pageWidth - 20, pageHeight - 13);

    // Texto izquierda
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    doc.setTextColor(100, 100, 100);
    doc.text(footerText, 20, pageHeight - 10);

    // Número de página derecha
    doc.text(
      `Página ${i} de ${pageCount}`,
      pageWidth - 20,
      pageHeight - 10,
      { align: "right" }
    );
  }


  // Guardar el archivo PDF
  doc.save("presupuesto.pdf");
}


// GENERAR EXCEL ***************************************************************************************************************
function estimateRowHeight(text = "", colWidthChars = 70, base = 18, perLine = 15) {
  const t = String(text || "");
  const lines = t.split("\n").reduce((acc, line) => {
    const wrapped = Math.max(1, Math.ceil(line.length / colWidthChars));
    return acc + wrapped;
  }, 0);

  return Math.min(300, Math.max(base, lines * perLine));
}
function toPlain(textOrHtml = "") {
  return htmlToPlainTextPreserveNewlines(textOrHtml || "");
}




// export async function generateExcel(oferta) {
//   // Brand
//   const BRAND_BLUE = "538DD5"; // sin #
//   const HEADER_FILL = { type: "pattern", pattern: "solid", fgColor: { argb: BRAND_BLUE } };

//   const wb = new ExcelJS.Workbook();
//   const ws = wb.addWorksheet("Oferta", {
//     pageSetup: { orientation: "portrait", fitToPage: true, fitToWidth: 1 },
//   });

//   ws.eachRow((row) => {
//   row.eachCell((cell) => {
//     cell.font = { name: "Calibri", size: 11 };
//   });
// });

//   // Columnas
// ws.columns = [
//   { key: "pos", width: 6 },
//   { key: "ud", width: 6 },
//   { key: "desc", width: 55 },
//   { key: "med", width: 10 },
//   { key: "precio", width: 12 },
//   { key: "total", width: 12 },
// ];

//   // Datos de cabecera
//   const fecha = oferta?.fecha ? formatDateES(new Date(oferta.fecha)) : formatDateES();
//   const numPres = oferta?.num_oferta || "";
//   const revision = oferta?.revision ?? 0;
//   const cliente = oferta?.cliente_nombre || "";
//   const localizacion = oferta?.localizacion || "";

//   // Logo
//   const logoBase64 = await fetchAsBase64("/media/logo/NEO4Logo_white.png");
//   const logoId = wb.addImage({ base64: logoBase64, extension: "png" });
//   ws.addImage(logoId, {
//     tl: { col: 4, row: 0 },          // E1
//     ext: { width: 187, height: 72 }, // como tu resultado
//     editAs: "oneCell",
//   });

//   // Cabecera filas
//   ws.getRow(1).height = 18;
//   ws.getRow(2).height = 18;
//   ws.getRow(3).height = 18;
//   ws.getRow(4).height = 18;

//   // Fecha (A1)
//   ws.getCell("A1").value = fecha;

//   // Título (A2) + revisión (D2)
//   ws.getCell("A2").value = `PRESUPUESTO Nº ${numPres}`;
//   ws.getCell("A2").font = { bold: true, size: 12 };

//   ws.getCell("D2").value = `Revisión ${revision}`;

//   // Cliente (A3..F3)
//   ws.getCell("A3").value = "Peticionario/Cliente:";
//   ws.getCell("A3").font = { bold: true };
//   ws.getCell("C3").value = cliente;

//   // Localización (A4..F4)
//   ws.getCell("A4").value = "Localización / Obra:";
//   ws.getCell("A4").font = { bold: true };
//   ws.getCell("C4").value = localizacion;

//   // Merges para que “respire”
//   ws.mergeCells("A3:B3");
//   ws.mergeCells("A4:B4");
//   ws.mergeCells("A2:C2"); // título ancho

//   // --- MEDICIONES: INSTALACIONES + Cabecera descripción ---
//   ws.addRow([]); // separador

//   // Barra azul (A..F)
//   const rMed = ws.addRow(["MEDICIONES:     INSTALACIONES", "", "", "", "", ""]);
//   ws.mergeCells(rMed.number, 1, rMed.number, 6); // A..F
//   rMed.height = 18;

//   rMed.eachCell((cell) => {
//     cell.fill = HEADER_FILL;
//     cell.font = { bold: true, color: { argb: "FFFFFF" } };
//     cell.alignment = { vertical: "middle", horizontal: "left" };
//     cell.border = {};
//   });

//   // Texto cabecera (A..F)
//   const cabecera = toPlain(oferta?.cabecera_descripcion || "");
//   if (cabecera) {
//     const rCab = ws.addRow([cabecera, "", "", "", "", ""]);
//     ws.mergeCells(rCab.number, 1, rCab.number, 6); // A..F

//     const c = rCab.getCell(1);
//     c.alignment = { vertical: "top", horizontal: "left", wrapText: true };

//     rCab.height = estimateRowHeight(cabecera, 90, 30, 14) + 8;
//   }

//   ws.addRow([]); // separador





//   // Inserta logo arriba a la derecha (aprox E1:F3)
//   // ws.addImage(logoId, {
//   //   tl: { col: 4.6, row: 0.1 },   // E1
//   //   ext: { width: 160, height: 45 }
//   // });



//   // Cabecera (fila 1: headers)
//   const headerRow = ws.getRow(1);
//   headerRow.font = { bold: true, color: { argb: "FFFFFF" } };
//   headerRow.fill = HEADER_FILL;
//   headerRow.alignment = { vertical: "middle", horizontal: "left" };
//   headerRow.height = 18;

//   // Formatos numéricos (2 decimales)
//   const moneyFmt = '#,##0.00 "€"';
//   const numFmt = "0.00";

//   // Helpers de estilo
//   const setTop = (cell) => (cell.alignment = { ...(cell.alignment || {}), vertical: "top" });
//   const setMid = (cell) => (cell.alignment = { ...(cell.alignment || {}), vertical: "middle" });

//   const setWrap = (cell) =>
//     (cell.alignment = { ...(cell.alignment || {}), wrapText: true });

//   // Por defecto: todo arriba
//   const applyDefaultRowStyle = (row) => {
//     row.eachCell((cell, colNumber) => {
//       setTop(cell);

//       // Columna Descripción: wrap
//       if (colNumber === 3) {
//         cell.alignment = {
//           vertical: "top",
//           horizontal: "left",
//           wrapText: true,
//         };
//       }

//       if (colNumber === 3) setWrap(cell);

//       // Med / Precio / Total: vertical middle + horizontal center (según pediste)
//       if ([4, 5, 6].includes(colNumber)) {
//         cell.alignment = { vertical: "middle", horizontal: "center", wrapText: false };
//       }

//       // Bordes suaves (opcional)
//       cell.border = {
//         top: { style: "thin", color: { argb: "E6E6E6" } },
//         left: { style: "thin", color: { argb: "E6E6E6" } },
//         bottom: { style: "thin", color: { argb: "E6E6E6" } },
//         right: { style: "thin", color: { argb: "E6E6E6" } },
//       };
//     });
//   };

//   // Fila capítulo (azul)
//   const addCapHeader = (text) => {
//     const r = ws.addRow(["", "", text, "", "", ""]);
//     ws.mergeCells(r.number, 3, r.number, 6); // C..F
//     r.height = 18;

//     r.eachCell((cell) => {
//       cell.fill = HEADER_FILL;
//       cell.font = { bold: true, color: { argb: "FFFFFF" } };
//       cell.alignment = { vertical: "middle", horizontal: "left", wrapText: false };
//       cell.border = {}; // sin borde
//     });
//     return r;
//   };
//   const addPartidasHeader = () => {
//     const r = ws.addRow(["Pos.", "Ud.", "Descripción", "Med.", "Precio", "Total"]);
//     r.font = { bold: true };
//     r.eachCell((cell) => {
//       cell.alignment = { vertical: "middle", horizontal: "center", wrapText: false };
//       cell.border = {
//         bottom: { style: "thin", color: { argb: "999999" } },
//       };
//     });
//     r.getCell(3).alignment = { vertical: "middle", horizontal: "left" };
//     return r;
//   };

//   // Fila subtotal capítulo (azul) con total a la derecha
//   const addCapTotal = (label, total) => {
//     const r = ws.addRow(["", "", label, "", "", Number(total || 0)]);
//     ws.mergeCells(r.number, 3, r.number, 5); // C..E
//     r.getCell(6).numFmt = moneyFmt;

//     r.eachCell((cell, col) => {
//       cell.fill = HEADER_FILL;
//       cell.font = { bold: true, color: { argb: "FFFFFF" } };
//       cell.alignment = { vertical: "middle", horizontal: col === 6 ? "right" : "left" };
//       cell.border = {};
//     });
//     return r;
//   };

//   // --- DATA ---
//   let totalPresupuesto = 0;

//   (oferta?.capitulos || []).forEach((cap) => {
//     const capIndex = (cap.ordinal ?? 0) + 1;
//     const capName = cap?.partida_categoria?.descripcion ?? "";
//     const capTitle = `Capítulo:    ${capIndex}     ${capName}`;
//     const EXTRA_HEIGHT = 12;

//     addCapHeader(capTitle);
//     addPartidasHeader();

//     (cap.partidas || []).forEach((p) => {
//   const titulo = (p.descripcion || "").trim();
// const detalle = htmlToPlainTextPreserveNewlines(p.concepto || "").trim();

// const pos = `${capIndex}.${(p.ordinal ?? 0) + 1}`;
// const ud = p.tipo_unidad || "Ud.";

// const unidades = Number(p.unidades || 0);
// const precio = Number(p.precio_unitario || 0);
// const total = Number(p.precio_total || 0);

// // ===============================
// // FILA 1 → POS + UD + TÍTULO
// // ===============================
// const row1 = ws.addRow([
//   pos,
//   ud,
//   titulo,
//   "",
//   "",
//   "",
// ]);

// // Merge descripción (C → F)
// ws.mergeCells(row1.number, 3, row1.number, 6);

// row1.getCell(1).alignment = { vertical: "top", horizontal: "center" };
// row1.getCell(2).alignment = { vertical: "top", horizontal: "center" };

// row1.getCell(3).alignment = {
//   vertical: "top",
//   horizontal: "left",
//   wrapText: true,
// };

// row1.getCell(3).font = { bold: true, name: "Calibri", size: 11 };

// row1.height = 16;

// row1.eachCell((cell) => {
//   cell.border = {
//     top: { style: "thin", color: { argb: "D0D0D0" } },
//     left: { style: "thin", color: { argb: "D0D0D0" } },
//     bottom: { style: "thin", color: { argb: "D0D0D0" } },
//     right: { style: "thin", color: { argb: "D0D0D0" } },
//   };
// });

// // ===============================
// // FILA 2 → DETALLE + VALORES
// // ===============================
// const row2 = ws.addRow([
//   "",
//   "",
//   detalle,
//   unidades,
//   precio,
//   total,
// ]);

// row2.getCell(4).numFmt = numFmt;
// row2.getCell(5).numFmt = moneyFmt;
// row2.getCell(6).numFmt = moneyFmt;

// // descripción
// row2.getCell(3).alignment = {
//   vertical: "top",
//   horizontal: "left",
//   wrapText: true,
// };

// // valores
// [4, 5, 6].forEach((col) => {
//   row2.getCell(col).alignment = {
//     vertical: "middle",
//     horizontal: "right",
//   };
// });

// // altura dinámica REALISTA
// row2.height = estimateRowHeight(detalle, 55, 16, 12);

// // bordes
// row2.eachCell((cell) => {
//   cell.border = {
//     top: { style: "thin", color: { argb: "D0D0D0" } },
//     left: { style: "thin", color: { argb: "D0D0D0" } },
//     bottom: { style: "thin", color: { argb: "D0D0D0" } },
//     right: { style: "thin", color: { argb: "D0D0D0" } },
//   };
// });
// });

//     // subtotal capítulo
//     addCapTotal(`TOTAL CAP:    ${capIndex}     ${capName}`, cap.total_precio);

//     totalPresupuesto += Number(cap.total_precio || 0);

//     // línea en blanco
//     ws.addRow([]);
//   });

//   // --- TOTALES FINALES ---
//   const totalSinIVA = Number(oferta?.calc_total_pvp || 0);
//   const ivaPct = Number(oferta?.valor_IVA || 0) * 100; // en PDF haces *100
//   const totalConIVA = Number(oferta?.total_PVP_IVA || 0);
//   const ivaEuros = +(totalConIVA - totalSinIVA).toFixed(2);

//   const addFinalRow = (label, value) => {
//     const r = ws.addRow(["", "", label, "", "", value]);
//     ws.mergeCells(r.number, 3, r.number, 5);
//     r.getCell(6).numFmt = moneyFmt;

//     r.eachCell((cell, col) => {
//       cell.fill = HEADER_FILL;
//       cell.font = { bold: true, color: { argb: "FFFFFF" } };
//       cell.alignment = { vertical: "middle", horizontal: col === 6 ? "right" : "left" };
//       cell.border = {};
//     });
//   };



//   // Filas estilo “barra azul”
//   addFinalRow("TOTAL SIN IVA", totalSinIVA);
//   addFinalRow(`Tipo de IVA APLICABLE (${ivaPct.toFixed(0)}%)`, ivaEuros);
//   addFinalRow("TOTAL IVA INCLUIDO", totalConIVA);

//   // Condiciones
//   const condiciones = htmlToPlainTextPreserveNewlines(oferta?.pie_condiciones_venta || "");
//   if (condiciones) {
//     addCapHeader("CONDICIONES DE GARANTIAS y VENTA");
//     const r = ws.addRow(["", "", condiciones, "", "", ""]);
//     ws.mergeCells(r.number, 3, r.number, 6);
//     r.getCell(3).alignment = { vertical: "top", horizontal: "left", wrapText: true };
//     r.height = estimateRowHeight(condiciones, 90, 60, 14);
//   }


//   ws.addRow([]);

//   // Descargar
//   const filename = `Oferta_${oferta?.num_oferta ?? oferta?.id ?? "export"}_${ts()}.xlsx`;
//   const buffer = await wb.xlsx.writeBuffer();
//   saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), filename);
// }


export async function generateExcel(oferta) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Hoja1", {
    pageSetup: { orientation: "portrait", fitToPage: true, fitToWidth: 1 },
  });

  const BLUE = "538DD5";
  const RED = "FF0000";
  const moneyFmt = '#,##0.00\\ "€"';
  const numFmt = "0.00";

  const fillRowBlue = (row, from = 2, to = 7) => {
    for (let col = from; col <= to; col++) {
      const cell = row.getCell(col);

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: BLUE },
      };

      cell.font = {
        name: "Arial",
        size: 12,
        bold: true,
        color: { argb: "FFFFFF" }, // 👈 CLAVE
      };

      cell.alignment = {
        vertical: "middle",
      };
    }
  };

  ws.columns = [
    { key: "ctrl", width: 4 },
    { key: "pos", width: 12.57 },
    { key: "ud", width: 9.14 },
    { key: "desc", width: 65.86 },
    { key: "med", width: 10.29 },
    { key: "precio", width: 14.14 },
    { key: "total", width: 18.86 },
  ];

  const setFont = (cell, opts = {}) => {
    cell.font = {
      name: opts.name || "Arial",
      size: opts.size || 12,
      bold: !!opts.bold,
      color: opts.color ? { argb: opts.color } : undefined,
    };
  };

  const setBlue = (cell, opts = {}) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: BLUE },
    };

    cell.font = {
      name: opts.name || "Arial",
      size: opts.size || 12,
      bold: opts.bold !== false,
      color: { argb: "FFFFFF" },
    };

    cell.alignment = {
      ...(cell.alignment || {}),
      vertical: "middle",
    };
  };

  const setRed = (cell, opts = {}) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: RED },
    };
    setFont(cell, { bold: true, size: opts.size || 14 });
  };

  const setWrap = (cell) => {
    cell.alignment = {
      vertical: "top",
      horizontal: "justify",
      wrapText: true,
    };
  };

  const setCenter = (cell) => {
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
    };
  };

  const fecha = oferta?.fecha
    ? formatDateES(new Date(oferta.fecha))
    : formatDateES();

  const numPres = oferta?.num_oferta || "";
  const revision = oferta?.revision ?? 0;
  const cliente = oferta?.cliente_nombre || "";
  const localizacion = oferta?.localizacion || "";

  ws.getRow(1).height = 21;
  ws.getRow(2).height = 18;
  ws.getRow(3).height = 18;

  ws.getCell("B1").value = "PRESUPUESTO  Nº ";
  setFont(ws.getCell("B1"), { name: "Arial Narrow", size: 12 });
  ws.getCell("B1").alignment = { vertical: "center" };

  ws.getCell("D1").value = numPres;
  setBlue(ws.getCell("D1"), { size: 16 });
  ws.getCell("D1").alignment = { vertical: "center", horizontal: "left" };

  ws.getCell("E1").value = "Revisión";
  setFont(ws.getCell("E1"), { size: 12 });

  ws.getCell("F1").value = revision;
  setFont(ws.getCell("F1"), { size: 12 });

  ws.getCell("B2").value = "Peticionario/Cliente:";
  setFont(ws.getCell("B2"), { size: 11 });
  ws.getCell("B2").alignment = { vertical: "center" };

  ws.getCell("D2").value = cliente;
  setFont(ws.getCell("D2"), { size: 14, bold: true });
  ws.getCell("D2").alignment = { vertical: "center" };

  ws.getCell("B3").value = "Localización / Obra:";
  setFont(ws.getCell("B3"), { name: "Arial Narrow", size: 12 });
  ws.getCell("B3").alignment = { vertical: "center" };

  ws.getCell("D3").value = localizacion;
  setFont(ws.getCell("D3"), { size: 14, bold: true });
  ws.getCell("D3").alignment = { vertical: "center" };

  ws.addRow([]);

 const rMed = ws.addRow(["", "MEDICIONES:     INSTALACIONES", "", "", "", "", ""]);

ws.mergeCells(rMed.number, 2, rMed.number, 7);

rMed.height = 18;

fillRowBlue(rMed, 2, 7);

rMed.getCell(2).alignment = {
  vertical: "middle",
  horizontal: "left",
};

  ws.addRow([]);

  const cabecera = toPlain(oferta?.cabecera_descripcion || "");
  if (cabecera) {
    const rCab = ws.addRow(["", "Sres:", "", cabecera, "", "", ""]);
    rCab.height = estimateRowHeight(cabecera, 70, 75, 15);
    setFont(rCab.getCell(2), { size: 12 });
    rCab.getCell(2).alignment = {
      vertical: "top",
      horizontal: "right",
      wrapText: true,
    };

    setFont(rCab.getCell(4), { size: 12 });
    setWrap(rCab.getCell(4));
  }

  ws.addRow([]);

  const addChapter = (capIndex, capName) => {
    const r = ws.addRow([
      "",
      "CAPÍTULO",
      capIndex,
      capName,
      "",
      "",
      "",
    ]);

    r.height = 18;

    fillRowBlue(r, 2, 7);

    r.getCell(2).alignment = { horizontal: "left", vertical: "middle" };
    r.getCell(3).alignment = { horizontal: "center", vertical: "middle" };
    r.getCell(4).alignment = { horizontal: "left", vertical: "middle" };

    return r;
  };

  const addPartidaHeader = () => {
    const r = ws.addRow(["", "Pos.", "Ud.", "Descripción", "Med.", "Precio", "Total"]);
    r.height = 18;

    [2, 3, 4, 5, 6, 7].forEach((col) => {
      const cell = r.getCell(col);
      setFont(cell, { size: 12, bold: true });
      cell.alignment =
        col === 4
          ? { vertical: "top", horizontal: "justify", wrapText: true }
          : { vertical: "center", horizontal: "center" };
    });
    [5, 6, 7].forEach((col) => {
      const cell = r.getCell(col);

      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    });

    return r;
  };

  const addPartida = (capIndex, partida) => {
    const titulo = (partida.descripcion || "").trim();
    const detalle = htmlToPlainTextPreserveNewlines(partida.concepto || "").trim();

    const pos = `${capIndex}.${(partida.ordinal ?? 0) + 1}`;
    const ud = partida.tipo_unidad || "Ud.";

    const unidades = Number(partida.unidades || 0);
    const precio = getFinalAmount(partida.precio_unitario_final, partida.precio_unitario);
    const total = getFinalAmount(partida.precio_total_final, partida.precio_total);

    const rTitle = ws.addRow(["", pos, ud, titulo, "", "", ""]);
    rTitle.height = estimateRowHeight(titulo, 70, 18, 15);

    setFont(rTitle.getCell(2), { size: 12, bold: true });
    setFont(rTitle.getCell(3), { size: 12, bold: true });
    setFont(rTitle.getCell(4), { size: 12 });

    setCenter(rTitle.getCell(2));
    setCenter(rTitle.getCell(3));
    setWrap(rTitle.getCell(4));

    const rDetail = ws.addRow(["", "", "", detalle, unidades, precio, total]);
    rDetail.height = estimateRowHeight(detalle, 70, 18, 15);

    setFont(rDetail.getCell(4), { size: 12 });
    setFont(rDetail.getCell(5), { size: 12 });
    setFont(rDetail.getCell(6), { size: 12 });
    setFont(rDetail.getCell(7), { size: 12, bold: true });

    setWrap(rDetail.getCell(4));
    setCenter(rDetail.getCell(5));
    setCenter(rDetail.getCell(6));
    setCenter(rDetail.getCell(7));

    rDetail.getCell(5).numFmt = numFmt;
    rDetail.getCell(6).numFmt = moneyFmt;
    rDetail.getCell(7).numFmt = moneyFmt;
  };

  const addCapTotal = (capIndex, capName, total) => {
    const r = ws.addRow([
      "",
      "TOTAL CAP:",
      capIndex,
      capName,
      "",
      "",
      Number(total || 0),
    ]);

    r.height = 18;

    fillRowBlue(r, 2, 7);

    r.getCell(2).alignment = { horizontal: "left", vertical: "middle" };
    r.getCell(3).alignment = { horizontal: "center", vertical: "middle" };
    r.getCell(4).alignment = { horizontal: "left", vertical: "middle" };

    r.getCell(7).numFmt = moneyFmt;
    r.getCell(7).alignment = {
      horizontal: "center",
      vertical: "middle",
    };

    return r;
  };

  (oferta?.capitulos || []).forEach((cap) => {
    const capIndex = (cap.ordinal ?? 0) + 1;
    const capName = getChapterTitle(cap);

    addChapter(capIndex, capName);
    ws.addRow([]);
    addPartidaHeader();

    (cap.partidas || []).forEach((partida) => {
      addPartida(capIndex, partida);
      ws.addRow([]);
    });

    addCapTotal(capIndex, capName, getFinalAmount(cap.total_precio_final, cap.total_precio));
    ws.addRow([]);
  });

  const totalSinIVA = getFinalAmount(oferta?.calc_total_pvp_final, oferta?.calc_total_pvp);
  const ivaPct = Number(oferta?.valor_IVA || 0);
  const totalConIVA = Number(oferta?.total_PVP_IVA || 0);
  const ivaEuros = +(totalConIVA - totalSinIVA).toFixed(2);

  const rTotalSin = ws.addRow(["", "", "", "TOTAL SIN IVA", "", "", totalSinIVA]);
  setBlue(rTotalSin.getCell(4));
  setBlue(rTotalSin.getCell(7));
  rTotalSin.getCell(7).numFmt = moneyFmt;

  const rIva = ws.addRow(["", "", "", "Tipo de IVA APLICABLE ………………………………………………..", ivaPct, "", ivaEuros]);
  rIva.height = 30;
  setFont(rIva.getCell(4), { size: 12 });
  setFont(rIva.getCell(5), { size: 12 });
  setFont(rIva.getCell(7), { size: 12 });
  rIva.getCell(5).numFmt = "0%";
  rIva.getCell(7).numFmt = moneyFmt;

  const rTotalCon = ws.addRow(["", "", "", "TOTAL IVA INCLUIDO ", "………………..", "", totalConIVA]);
  rTotalCon.height = 18;
  setRed(rTotalCon.getCell(4));
  setRed(rTotalCon.getCell(5));
  setRed(rTotalCon.getCell(7));
  rTotalCon.getCell(4).alignment = { horizontal: "right" };
  rTotalCon.getCell(7).numFmt = moneyFmt;

  const condiciones = htmlToPlainTextPreserveNewlines(oferta?.pie_condiciones_venta || "");
  if (condiciones) {
    ws.addRow([]);
    const rCondTitle = ws.addRow(["", " CONDICIONES DE GARANTIAS y VENTA", "", "", "", "", ""]);
    setBlue(rCondTitle.getCell(2));

    const rCond = ws.addRow(["", "", "", condiciones, "", "", ""]);
    rCond.height = estimateRowHeight(condiciones, 70, 60, 15);
    setWrap(rCond.getCell(4));
    setFont(rCond.getCell(4), { size: 12 });
  }

  const filename = `Oferta_${oferta?.num_oferta ?? oferta?.id ?? "export"}_${ts()}.xlsx`;
  const buffer = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename
  );
}
